import React from 'react';

import { useTypedTranslation } from '@app/hooks';
import { IAgentDetail, IClientRoles } from '@app/models';
import { AgentViewType } from '@app/pages/authManager/dialogs/addAgent.dialog';
import { useSelector } from 'react-redux';

interface IProps {
    editAgentCallback: Function;
    agent: IAgentDetail;
    oauth2Config: IClientRoles[];
};

const ReadOauth2Config: React.SFC<IProps> = ({ editAgentCallback, agent, oauth2Config }) => {
    const { translation } = useTypedTranslation();

    const shellConfig: any = useSelector((state: any) => state.basic.shellConfig);

    const resolveOrgName = (item: any) => {
        if (item && item.OrganizationId) {
            const orgs: any = shellConfig.organizations;

            for (let org of orgs) {
                if (org.id === item.OrganizationId) {
                    return org.name;
                }
            }
        }

        return null;
    };

    return (
        <div className='detailPage__section'>
            <div className='detailPage__section-head'>
                {translation('OAUTH2_CLIENT_CONFIGURATION_TAB')}
            </div>
            <div className='detailPage__section-content'>
                <ul className='detailPage__list'>
                    <li>
                        <a id='editAgentLink' className='detailPage__list--primary-label' onClick={() => editAgentCallback(AgentViewType.editAgentExtendedView)}>{translation('EDIT')}</a>
                    </li>
                    {oauth2Config.length > 0 ?
                        <>
                            <span className='detailPage__list--primary-label'>{translation('PERMISSIONS')}</span>
                            <span className='detailPage__list--secondary-label'>
                                <ul className='detailPage__secondary-list'>
                                    {oauth2Config.map((item: any, index: number) => (
                                        <li key={index}>
                                            <span>{item.Name}&nbsp;</span>
                                            <span className='detailPage__item-highlight'>({resolveOrgName(item)})</span>
                                        </li>
                                    ))}
                                </ul>
                            </span>
                        </>
                        :
                        <span className='detailPage__list--secondary-label'>
                            {translation('NO_PERMISSIONS')}
                        </span>
                    }
                </ul>
            </div>
        </div>
    );
};

export default ReadOauth2Config;